import script from "./ToggleElement.vue?vue&type=script&lang=js"
export * from "./ToggleElement.vue?vue&type=script&lang=js"

import "./ToggleElement.vue?vue&type=style&index=0&id=27d53b6e&lang=scss"

const __exports__ = script;

export default __exports__